/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Dashboard } from './pages/Dashboard';
import { AutoFollowUp } from './pages/AutoFollowUp';
import { AIKnowledgeBase } from './pages/AIKnowledgeBase';
import { Calling } from './pages/Calling';
import { ConversionFlow } from './pages/ConversionFlow';
import Templates from './pages/Templates';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="auto-follow-up" element={<AutoFollowUp />} />
            <Route path="ai-knowledge-base" element={<AIKnowledgeBase />} />
            <Route path="calling" element={<Calling />} />
            <Route path="conversion-flow" element={<ConversionFlow />} />
            <Route path="templates" element={<Templates />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
